export default __webpack_public_path__ + "static/media/fail_mobile.60753a87.svg";